import { CONTENT_TYPE } from '../interfaces/create-template.interface';

export const createTemplateFormControlConstant = {
  NAME: 'name',
  LANGUAGE: 'language',
  PRE_CHECK_PATH: 'preCheckPath',
  IS_CAROUSEL: 'isCarousel',
  LEGALLY_APPROVED: 'legallyApproved',
  TRAI_APPROVED: 'traiApproved',
  DPM_APPROVED: 'dpmApproved',
  META_APPROVED: 'metaApproved',
  GOOGLE_APPROVED: 'googleApproved',
  CHANNEL: 'channel',
  IS_MEDIA: 'isMedia',
  MEDIA_TYPE: 'mediaType',
  MEDIA_URL: 'mediaUrl',
  CONTENT: 'content',
  CAROUSEL_MEDIA_TYPE: 'carouselMediaType',
  CAROUSEL_LABEL_TYPE: 'carouselLabelType',
  CAROUSEL_MEDIA_CHANNEL: 'carouselMediaChannel',
  GOOGLE_TEMPLATE_NAME: 'googleTemplateName',
  FIREBASE_TEMPLATE_NAME: 'fireBaseTemplateName',
  META_ID: 'metaTemplateName',
  MEDIA_META_ID: 'mediaMetaId',
  MEDIA_FILE_NAME: 'mediaFileName',
  MEDIA_CHANNEL: 'mediaChannel',
  LABEL_TYPE: 'labelType',
  THUMBNAIL_LABEL_TYPE: 'thumbnailLabelType',
  SECTION: 'section',
  CARD_TEXT: 'cardText',
  CARD_IMAGE: 'cardImage',
  BUTTON_ACTION: 'action',
  BUTTON_LABEL: 'label',
  URL: 'url',
  BUTTONS_ARRAY: 'button',
  MEDIA_ID: 'mediaId',
  CONTACT_NUMBER: 'number',
  FORM_CODE: 'formCode',
  IS_BUTTON: 'isButton',
  BUTTON_REQUESTS: 'buttonRequests',
  FOOTER: 'footer',
  DLT_ID: 'dltId',
  SENDER_ID: 'senderId',
  PRINCIPAL_ID: 'principalId',
  CATEGORY: 'category',
  ORGANIZATION: 'organization',
  VERTICAL: 'vertical',
  DIVISION: 'division',
  DEPARTMENT: 'department',
  TEMPLATE_CATEGORY: 'templateCategory',
  MEDIA_EXTENSION: 'mediaExtension',
  APPROVAL_SOURCE: 'approvedSource',
  SOURCE_APPROVED: 'sourceApproved',
  STATUS: 'status',
  MEDIA_FILE: 'mediaFile',
  URL_SHORTENING: 'urlShorten',
  MESSAGE_COUNT: 'messageCount',
  BSP: 'bsp',
  BOT_NUMBER: 'botNumber',
  ORIENTATION: 'orientation',
  MEDIA_HEIGHT: 'height',
  MEDIA_WIDTH: 'width',
  LAYOUT: 'layout',
  CARD_TITLE: 'cardTitle',
  CARD_DESCRIPTION: 'cardDesc',
  RESPONSE_TEXT: 'responseText',
  LATITUDE: 'latitude',
  LONGITUDE: 'longitude',
  LOCATION_LABEL: 'locationLabel',
  EVENT_START_DATE_TIME: 'eventStartDateTime',
  EVENT_END_DATE_TIME: 'eventEndDateTime',
  EVENT_TITLE: 'eventTitle',
  EVENT_DESCRIPTION: 'eventDesc',
  STATIC_URL: 'staticUrl',
  STATIC_THUMBNAIL_URL: 'staticThumbnailUrl',
  NUMBER_FORMAT: 'numberFormat',
  ALIGNMENT: 'alignment',
  VIDEO_THUMBNAIL: 'videoThumbnail',
  VIDEO_THUMBNAIL_NAME: 'videoThumbnailName',
  EVENT_TIMEZONE: 'eventTimezone',
  TITLE: 'title',
  APPLICATION: 'appName',
  URL_SHORTEN_WHATSAPP: 'urlShortenWhatsapp',
  BASE_URL: 'baseUrl',
  TITLE_TYPE: 'titleType',
  SHORTENER_TYPE: 'shortenerType',
  SHORTENER_TYPE_TOGGLE: 'shortenerTypeToggle',
  SHORTENER_PROVIDER: 'shortenerProvider',
  CODE: 'code',
  CTA_SHORT_URL: 'ctaShortUrl',
};

export const EmailContentType = {
  IMAGE: 'IMAGE' as CONTENT_TYPE,
  TEXT: 'TEXT' as CONTENT_TYPE,
  BUTTON: 'BUTTON' as CONTENT_TYPE,
};

export const EmailTemplateJSONStorageKey = 'templateLayoutJson';

export const ScreenLayout = {
  ONE_FIELD_LAYOUT: '1',
  TWO_FIELDS_LAYOUT: '2',
  THREE_FIELDS_LAYOUT: '3',
  FOUR_FIELDS_LAYOUT: '4',
};

export const NumberFormat = {
  DIGITS: '10 Digit',
  FREE_LENGTH: 'Free Length',
};

export const CallBack = {
  STATIC: 'STATIC_CALLBACK',
  DYNAMIC: 'DYNAMIC_CALLBACK',
};

export const APPROVAL_FORM_CONTROL_MAPPER: any = {
  LEGALLY: createTemplateFormControlConstant.LEGALLY_APPROVED,
  TRAI: createTemplateFormControlConstant.TRAI_APPROVED,
  DPM: createTemplateFormControlConstant.DPM_APPROVED,
  META: createTemplateFormControlConstant.META_APPROVED,
  GOOGLE: createTemplateFormControlConstant.GOOGLE_APPROVED,
};

export const formUrlPlaceholder = {
  FORM_URL: '#form_url#',
  TINY_FORM_URL: '#form_url_tiny#',
};
